class VariantBundles {

    constructor(elementSelector) {

        if (typeof elementSelector == 'undefined') {
            console.log('missing information');
            return;
        }

        this.elementSelector = elementSelector;
        this.element = $(this.elementSelector);
        this.usedProductsList = [];

        this.supplierDropdownLength = this.element.find('#supplier > option').length - 1;

        this.specificationValue = 0;

        this.events();

        this.load();
    }

    events() {

        let self = this;

        $(document).on('change', this.elementSelector +' #variant_bundle_property', function() {

            $(self.elementSelector +' .products').addClass('d-none');
            if ($(this).val() != 0) {
                $(self.elementSelector +' .products').removeClass('d-none');
                self.specificationValue = $(this).val();
                self.getProducts(self.specificationValue);
            }

            self.setData();
        });

        $(document).on('click', this.elementSelector+' .btn-product-add', function() {
            
            self.add();
            self.setData();
            self.usedProducts();
        });
      
        $(document).on('click', this.elementSelector +' .btn-product-delete', function() {
            $(this).closest('.product-row').remove();
            self.checkSuppliersCount();
            self.setData();
        });

        $(document).on('change', this.elementSelector + ' .products-container .products-input', function () {


            self.usedProducts();
            self.setData();
        });
    }

    load() {

        let self = this,
            data = JSON.parse(this.element.find('#products_variants_bundle_data').val());

        this.specificationValue = data.specification_value;
        this.element.find('#variant_bundle_property').selectpicker('val', this.specificationValue);
        if (data.products) {
            data.products.forEach(function(item) {
                self.add(item);
            });
        }

        this.setData();
        this.usedProducts();
    }

    usedProducts() {

        let data = JSON.parse(this.element.find('#product_ids').val());
        let self = this;

        this.usedProductsList = [];

        for (let key in data) {
            self.usedProductsList.push(data[key]);
        }

        this.disableProductsDropdown(this.element.find('.products-container select'))
    }

    getProducts(specificationId) 
    {
        let self = this;

        $.ajax({
            url: config.domain + "/" + config.app + "/functions/get_variant_bundle_products.php",
            type: 'post',
            data: {
                "specification_id": specificationId
            },
            success: function (response) {
                console.log(response);

                // self.element.find('#products_variants_bundle_data').val(JSON.stringify(response));
                self.element.find('#products_variants_bundle_data').val(response);

                self.load();
                // self.specificationValue = response.specification_value;
                // if (response.products) {
                //     response.products.forEach(function (item) {
                //         self.add(item);
                //     });
                // }
                // self.setData();
            }   
        });
    }

    disableProductsDropdown(element)
    {
        let self = this;

        console.log(element)

        element.each(function () {
            var selected = $(this).val();
            $(this).find("option").each(function () {
                $(this).removeAttr('disabled');
                $(this).prop('disabled', false);
                if (selected != $(this).val() 
                    && $.inArray($(this).val(), self.usedProductsList) != -1 &&
                    $(this).val() != '0') {
                    $(this).attr('disabled', 'disabled');
                    $(this).prop('disabled', true);
                }
            });

            $(this).selectpicker('destroy');
            $(this).selectpicker('render');

        });
    }

    removeAddButton() {

        if (this.element.find('.products-container .product-row').length >= this.supplierDropdownLength) {
            this.element.find('.products-controls').addClass('d-none');
        }
        
        if (this.element.find('.products-container .product-row').length < this.supplierDropdownLength) {
            this.element.find('.products-controls').removeClass('d-none');
        }
    }

    add(item) {

        let self = this;

        let product = $(this.element.find('.product-template').html());

        product.data('hash', Math.floor(Math.random() * 1000));

        product.find('#product').selectpicker('render');

        if (typeof item != 'undefined') {
            product.find('#product').selectpicker('val', item.id);
            $(this.elementSelector +' .products').removeClass('d-none');
        }

        product.addClass('mt-2');

        this.element.find('.products-container').append(product);

        this.checkSuppliersCount();
    }

    checkSuppliersCount()
    {
        if (this.element.find('.products-container .product-row').length > 0) {

            this.element.find('.products-container')
                .removeClass('col-8')
                .addClass('col-12');

            this.element.find('.products-controls')
                .removeClass('col-4')
                .addClass('col-12');

            this.element.find('.products-container .no-products').hide();
        } else {

            this.element.find('.products-container')
                .removeClass('col-12')
                .addClass('col-8');

            this.element.find('.products-controls')
                .removeClass('col-12')
                .addClass('col-4');

            this.element.find('.products-container .no-products').show();
        }
    }

    setData() 
    {
        let self = this,
            data = [];

        let products = [];
        this.element.find('.products-container .product-row').each(function() {
            products.push({
                'id': $(this).find('#product').val()
            });
        });

        if (self.specificationValue ||  
            products.length > 0) {

            let item = {
                specification_value: self.specificationValue,
                products: products
            };
    
            data.push(item);
        }

        this.data = data;

        this.element.find('#products_variants_bundle_data').val(JSON.stringify(this.data));
    }
}